import { CheckRounded } from "@mui/icons-material";

export const checked = (props) => {
  return <CheckRounded {...props} />;
};
